// Function to adjust the slider width based on sidebar visibility
function adjustSliderWidth() {
  const carousel = document.querySelector(".video-carousel");
  const sidebar = document.getElementById("sidebar-group");

  if (sidebar.classList.contains("visible")) {
    if (carousel) {
      carousel.style.width = "80%";
    }
  } else {
    if (carousel) {
      carousel.style.width = "100%";
    }
  }

  setTimeout(() => {
    initializeVideoCarousel();
  }, 300);
}

// Initialize carousel on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  initializeVideoCarousel();
  adjustSliderWidth();
});

// Re-run slider logic when the sidebar visibility changes
document.addEventListener("sidebar:visibilityChanged", () => {
  adjustSliderWidth();
});

// Slider initialization function
function initializeVideoCarousel() {
  const carousels = document.querySelectorAll(".video-carousel");

  carousels.forEach((carousel) => {
    const autoplay = carousel.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;

    let previous = 0;

    carousel.classList.remove("keen-slider-initialized");
    carousel.style.visibility = "hidden";
    carousel.style.height = "0";

    const slider = new KeenSlider(carousel, {
      loop: true,
      mode: "snap",
      slides: {
        origin: "center",
        perView: 3,
        spacing: 16,
      },
      breakpoints: {
        "(max-width: 768px)": {
          slides: {
            origin: "center",
            perView: 1.5,
            spacing: 12,
          },
        },
      },

      created() {
        carousel.classList.add("keen-slider-initialized");
        carousel.style.visibility = "visible";
        carousel.style.height = "auto";
      },

      slideChanged(s) {
        const current = s.track.details.rel;
        const slides = s.slides;

        slides.forEach((slide) =>
          slide.classList.remove("fade-animate", "looped-start")
        );

        const newSlideIndex = (current + 1) % slides.length;
        void slides[newSlideIndex].offsetWidth;
        slides[newSlideIndex].classList.add("fade-animate");
      },

      move(s) {
        const current = s.track.details.rel;
        if (previous > current) {
          const loopedSlide = s.slides[current];
          loopedSlide.classList.remove("looped-start");
          void loopedSlide.offsetWidth;
          loopedSlide.classList.add("looped-start");
        }
        previous = current;
      },
    });

    // Prev/Next controls
    const prevBtn = carousel.querySelector(".prev-button");
    const nextBtn = carousel.querySelector(".next-button");

    prevBtn?.addEventListener("click", () => slider.prev());
    nextBtn?.addEventListener("click", () => slider.next());

    // Dot navigation
    const dotContainer = carousel.nextElementSibling;
    if (dotContainer?.classList.contains("carousel-dots")) {
      dotContainer.innerHTML = "";

      for (let i = 0; i < slider.track.details.slides.length; i++) {
        const dot = document.createElement("button");
        dot.classList.add("dot");
        dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
        dot.addEventListener("click", () => slider.moveToIdx(i));
        dotContainer.appendChild(dot);
      }

      const updateDots = () => {
        const active = slider.track.details.rel;
        dotContainer
          .querySelectorAll(".dot")
          .forEach((dot, idx) => dot.classList.toggle("active", idx === active));
      };

      slider.on("slideChanged", updateDots);
      updateDots();
    }

    // ✅ Autoplay
    if (autoplay) {
      let autoplayTimeout;
      let isPaused = false;

      const autoPlayFn = () => {
        clearTimeout(autoplayTimeout);
        if (!isPaused) {
          autoplayTimeout = setTimeout(() => {
            slider.next();
            autoPlayFn();
          }, autoplaySpeed);
        }
      };

      autoPlayFn();

      // Pause on hover
      carousel.addEventListener("mouseenter", () => {
        isPaused = true;
        clearTimeout(autoplayTimeout);
      });

      carousel.addEventListener("mouseleave", () => {
        isPaused = false;
        autoPlayFn();
      });
    }
  });
}

// Video modal logic
const modal = document.getElementById("videoModal");
const iframe = document.getElementById("videoIframe");
const videoCards = document.querySelectorAll(".video-thumb");

videoCards.forEach((card) => {
  card.addEventListener("click", () => {
    const videoId = card.getAttribute("data-video-id");
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
    modal.style.display = "flex";
  });
});

document.getElementById("closeModal")?.addEventListener("click", () => {
  modal.style.display = "none";
  iframe.src = "";
});

window.addEventListener("click", (event) => {
  if (event.target === modal) {
    modal.style.display = "none";
    iframe.src = "";
  }
});
